/**
 * @generated SignedSource<<ca7d1aa3b1eebc780098ee476de86964>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesSwitcher_stream$data = {
  readonly account: {
    readonly id: string;
    readonly image: string;
    readonly name: string;
  };
  readonly isExternal: boolean;
  readonly relatedStreams: ReadonlyArray<{
    readonly account: {
      readonly id: string;
      readonly name: string;
    };
    readonly id: string;
    readonly isExternal: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"SeriesSwitcherOption_stream">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesSwitcherOption_stream" | "SeriesSwitcher_ExternalStreamTooltip_stream">;
  readonly " $fragmentType": "SeriesSwitcher_stream";
};
export type SeriesSwitcher_stream$key = {
  readonly " $data"?: SeriesSwitcher_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesSwitcher_stream">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "SeriesSwitcherOption_stream"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesSwitcher_stream",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": "image",
          "args": null,
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeriesSwitcher_ExternalStreamTooltip_stream"
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "relatedStreams",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "account",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "a1e1cbf103a00048a7981e810737445d";

export default node;
